import { render, staticRenderFns } from "./register-student.vue?vue&type=template&id=2b744232&"
import script from "./register-student.vue?vue&type=script&lang=js&"
export * from "./register-student.vue?vue&type=script&lang=js&"
import style0 from "./register-student.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports